import { Row, Col } from 'antd';
import './Breadcrumbs.scss';
import { useLocation, useNavigate } from 'react-router-dom';

interface Props {
    data?: any
    to?: () => void
    title?: string
}

const Breadcrumbs = (Props: Props) => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="breadcrumbs">
            <Row>
                <Col className="header-columns-left" xs={24} sm={12} md={6} lg={12}>
                    <p className='breadcrumbs-text-light flex'>
                        <a className='breadcrumbs-text-light flex' href="#/" onClick={($event) => {
                            $event.preventDefault();
                            if (location.pathname.includes("entities")
                                || location.pathname.includes("searchers")
                                || location.pathname.includes("groups")
                                || location.pathname.includes("universities")) {
                                navigate('/entities');
                            } else {
                                navigate('/capacities');
                            }
                        }}>{Props?.title || 'Entidades'}</a>
                        <span className='flex'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="14" viewBox="0 0 18 18" fill="none">
                                <path d="M6.29947 16.2001L11.5495 10.9501L6.29947 5.7001L7.34947 3.6001L14.6995 10.9501L7.34947 18.3001L6.29947 16.2001Z" fill="black" />
                            </svg>
                        </span>
                        <span style={{ color: 'black', fontWeight: 500 }} className='flex'>
                            <svg style={{ margin: 20 }} width="3" height="24" viewBox="0 0 3 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="1.05" x2="1.05" y2="38.85" stroke="#9F9F9F" stroke-width="2.1" />
                            </svg>
                            {Props.data[0]?.name || ''}
                        </span>
                    </p>
                </Col>
                <Col className="header-columns-right" xs={24} sm={12} md={6} lg={12}></Col>
            </Row>
        </div>
    );
}

export default Breadcrumbs;